import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IDownloadSoftwareModel } from './download-software.interface';
import { SoftwareDownloadService } from './software-download.service';

@Component({
  selector: 'app-software-download',
  templateUrl: './software-download.component.html',
  styleUrls: ['./software-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoftwareDownloadComponent implements OnInit {
  protected softwareVersions: IDownloadSoftwareModel[];
  protected readonly today = Date.now();
  protected cloudBasePath: string;
  protected currentHostPath: string;

  public constructor(
    private softwareDownloadService: SoftwareDownloadService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.currentHostPath = environment.currentHostPath;
    this.softwareDownloadService.getDownloadSoftware().subscribe((data) => {
      this.softwareVersions = data;
      this.cdr.detectChanges();
    });
  }

  identify(index: number, item: { id: number }) {
    return item.id;
  }

  trackConsoleType(index: number, item: { consoleTypes: string }) {
    return item.consoleTypes;
  }
}
